import { z } from 'zod';
import type { DeepUndefinedOrNull } from '@/types/partial';
import { ProdutoAdicionalItemStatus } from './enum';

export const ProdutoAdicionalItemSchema = z.object({
    pai_aceita_multiplos: z.enum(['S', 'N']),
    pai_data_insercao: z.string(),
    pai_detalhes: z.string().nullable(),
    pai_empresa_idpk: z.number(),
    pai_idpk: z.string(),
    pai_imagem: z.string().nullable(),
    pai_nome: z.string(),
    pai_produto_adicional_idpk: z.string().nullable(),
    pai_produto_idpk: z.number(),
    pai_status: z.enum(ProdutoAdicionalItemStatus),
    pai_ultima_alteracao: z.string().nullable(),
    pai_valor_unitario: z.number(),
});

type ProdutoAdicionalItem = z.infer<typeof ProdutoAdicionalItemSchema>;

export type ProdutoAdicionalItemBody = DeepUndefinedOrNull<ProdutoAdicionalItem> & {
    key: string;
    imagem_nome?: string | null | undefined;
    imagem_base64?: string | null | undefined;
    excluir?: 'S';
};
